module.exports = {
	"config": {
		"blogTitle": "Maxim Siebert",
		"authorName": "Maxim Siebert",
		"linkPrefix": "/gatsby-starter-blog"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "",
				"stem": "_template",
				"path": "_template.js"
			},
			"requirePath": "_template.js",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-05-04-tachy-tools",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-05-04-tachy-tools",
				"stem": "index",
				"path": "2017-05-04-tachy-tools/index.md"
			},
			"requirePath": "2017-05-04-tachy-tools/index.md",
			"path": "/tachy-tools/",
			"data": {
				"title": "Tachy Tools",
				"role": "Branding, Design & Development",
				"client": "Personal",
				"description": "A growing collection of templates for designers & developers",
				"specifics": "Templates built using Tachyons & Unsplash without any custom CSS",
				"link": "http://tachy.tools/",
				"date": "2017-05-05T22:12:03.284Z",
				"img": "tachy-1.jpg",
				"imgHeader": "tachy-2.jpg",
				"readNext": "/vice-news/",
				"path": "/tachy-tools/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-05-05-vice-news",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-05-05-vice-news",
				"stem": "index",
				"path": "2017-05-05-vice-news/index.md"
			},
			"requirePath": "2017-05-05-vice-news/index.md",
			"path": "/vice-news/",
			"data": {
				"title": "VICE News",
				"role": "Design & Front-end Development",
				"client": "Postlight",
				"clientLink": "https://postlight.com/",
				"description": "Telling the news in a brutalist & illustrated way",
				"specifics": "A Wordpress site with extremely customizable functionality",
				"link": "https://news.vice.com/",
				"date": "2017-05-05T22:12:03.284Z",
				"img": "vice-news-1.jpg",
				"imgHeader": "vice-news-2.jpg",
				"readNext": "/bac-ky/",
				"path": "/vice-news/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-05-06-bac-ky",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-05-06-bac-ky",
				"stem": "index",
				"path": "2017-05-06-bac-ky/index.md"
			},
			"requirePath": "2017-05-06-bac-ky/index.md",
			"path": "/bac-ky/",
			"data": {
				"title": "Bac Ky",
				"role": "Design & Development",
				"client": "Personal",
				"description": "A simple & delightful website for a delicious restaurant",
				"specifics": "One-page Squarespace site with subtle parallax",
				"link": "http://blunt.af/bac-ky/",
				"date": "2017-05-06T22:12:03.284Z",
				"img": "bac-ky-1.jpg",
				"imgHeader": "bac-ky-2.jpg",
				"readNext": "/beautiful-stores/",
				"path": "/bac-ky/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-05-07-beautiful-stores",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-05-07-beautiful-stores",
				"stem": "index",
				"path": "2017-05-07-beautiful-stores/index.md"
			},
			"requirePath": "2017-05-07-beautiful-stores/index.md",
			"path": "/beautiful-stores/",
			"data": {
				"title": "Beautiful Stores",
				"role": "Branding, Design & Development",
				"client": "Personal",
				"description": "Inspiring entrepreneurs & ecommerce designers",
				"specifics": "A Shopify store that showcases hand-selected beautiful ecommerce websites",
				"link": "https://beautifulstores.com/",
				"date": "2017-05-07T22:12:03.284Z",
				"img": "bs-1.jpg",
				"imgHeader": "bs-2.jpg",
				"readNext": "/venture/",
				"path": "/beautiful-stores/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-05-08-venture",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-05-08-venture",
				"stem": "index",
				"path": "2017-05-08-venture/index.md"
			},
			"requirePath": "2017-05-08-venture/index.md",
			"path": "/venture/",
			"data": {
				"title": "Venture",
				"role": "Branding & Design",
				"client": "Shopify",
				"clientLink": "https://www.shopify.com/",
				"description": "Ecommerce theme for sports & recreation brands",
				"specifics": "A Shopify theme ideal for high inventory stores",
				"link": "https://themes.shopify.com/themes/venture/styles/snowboards",
				"date": "2017-05-08T22:12:03.284Z",
				"img": "venture-1.jpg",
				"imgHeader": "venture-2.jpg",
				"readNext": "/talkboxes/",
				"path": "/venture/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2017-05-09-talkboxes",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2017-05-09-talkboxes",
				"stem": "index",
				"path": "2017-05-09-talkboxes/index.md"
			},
			"requirePath": "2017-05-09-talkboxes/index.md",
			"path": "/talkboxes/",
			"data": {
				"title": "Talkboxes",
				"role": "Branding, Design & Development",
				"client": "Personal",
				"description": "Community curated talks for designers & developers from conferences everywhere",
				"specifics": "A Craft CMS site with front-facing user login and sign up",
				"link": "http://talkboxes.co",
				"date": "2017-05-09T22:12:03.284Z",
				"img": "talkboxes-1.jpg",
				"imgHeader": "talkboxes-2.jpg",
				"path": "/talkboxes/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.js",
				"ext": "js",
				"name": "404",
				"extname": ".js",
				"basename": "404.js",
				"dirname": "",
				"stem": "404",
				"path": "404.js"
			},
			"requirePath": "404.js",
			"path": "/404/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "about.js",
				"ext": "js",
				"name": "about",
				"extname": ".js",
				"basename": "about.js",
				"dirname": "",
				"stem": "about",
				"path": "about.js"
			},
			"requirePath": "about.js",
			"path": "/about/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "images",
				"base": "manifest.json",
				"ext": "json",
				"name": "manifest",
				"extname": ".json",
				"basename": "manifest.json",
				"dirname": "images",
				"stem": "manifest",
				"path": "images/manifest.json"
			},
			"requirePath": "images/manifest.json",
			"path": "/images/manifest/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js"
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 385
// module chunks = 0